<!--
 * @Description: 系统设置代付配置
 * @Author: xu wei
 * @Date: 2020-02-26 15:38:07
 * @LastEditTime: 2020-06-02 11:03:19
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>代付配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <div class="pdb10">
        <el-button size="small" type="primary" @click="addpaydata.show = true">添加</el-button>
      </div>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" label="编号" width="60"></el-table-column>
        <el-table-column prop="markName" label="名称">
        </el-table-column>
        <el-table-column label="代付类型">
          <template slot-scope="scope">
            <span>{{scope.row.mark| fpaytype}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountName" label="付款账号">
        </el-table-column>
        <el-table-column prop="remark" label="付款备注">
        </el-table-column>
        <el-table-column label="操作" width='150'>
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="payinfo(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleClose(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 添加弹框 -->
    <el-dialog :title="addpaydata.flag?'配置代付':'编辑代付'" :visible.sync="addpaydata.show" @close="addinit" custom-class="gs_dialog" width="900px">
      <div class="dialoglist">
        <ul>
          <li class="clearfix">
            <span class='tit'>代付类型</span>
            <span class="txtbox">
              <el-select v-model="addpaydata.paytype" placeholder="请选择" style="width:300px;">
                <el-option v-for="(item,i) in addpaydata.paylist" :key="'type'+i" :label="item.text" :value="item.value"></el-option>
              </el-select>
              <span class="tip">支付宝代付可配置多个账号</span>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>代付名称</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.name"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>支付网关</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.net"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>商户号</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.accout" style="width:300px;"></el-input>
              <span class="tip">支付宝：partner，微信：商户号(mchid)</span>
            </span>
          </li>
          <li class="clearfix" v-if="addpaydata.paytype==='alipay'">
            <span class='tit'>付款账户名</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.accoutname"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>付款账号</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.payaccout" style="width:300px;"></el-input>
              <span class="tip">支付宝：email或手机号，微信：账号appid</span>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>付款备注</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.remark"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>密钥</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.subcode"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>公钥</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.pubcode" placeholder="支付宝代付需填写"></el-input>
            </span>
          </li>
          <li class="clearfix" v-if="addpaydata.paytype==='wechat'">
            <span class='tit'>授权密钥</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.supsubcode" style="width:300px;"></el-input>
              <span class="tip">微信代付需用户获取网页授权(绑定微信号)</span>
            </span>
          </li>
          <li class="clearfix" v-if="addpaydata.paytype==='wechat'">
            <span class='tit'>授权域名</span>
            <span class="txtbox">
              <el-input v-model="addpaydata.area" style="width:300px;"></el-input>
              <span class="tip">微信代付-网页授权域名</span>
            </span>
          </li>
        </ul>
      </div>
      <div class="button_center tc pdb20 pdt10">
        <el-button type="primary" @click="payadd" v-if="addpaydata.flag">提交</el-button>
        <el-button type="primary" @click="payupdate" v-else>提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numberperpage: '', // 每页数量
      numberdrow: '', // 每页数量下拉
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      options: [],
      tableData: [],
      addpaydata: {
        flag: true,
        show: false,
        id: '', // 编辑时的ID
        paytype: 'alipay', // 代付类型
        paylist: [
          { value: 'alipay', text: '支付宝' },
          { value: 'wechat', text: '微信' },
          { value: 'longbao', text: '龙宝' }
        ],
        name: '', // 代付名称
        net: '', // 支付网关
        accout: '', // 商户号
        accoutname: '', // 付款账户名
        payaccout: '', // 付款账号
        remark: '', // 付款备注
        subcode: '', // 密钥
        pubcode: '', // 公钥
        supsubcode: '', // 授权密钥
        area: '' // 授权域名
      }
    };
  },
  filters: {
    fpaytype: function(data) {
      let state = '';
      switch (data) {
        case 'alipay':
          state = '支付宝';
          break;
        case 'wechat':
          state = '微信';
          break;
        case 'longbao':
          state = '龙宝';
          break;
        default:
          state = '支付宝';
          break;
      }
      return state;
    }
  },
  methods: {
    // 代付列表
    getlist() {
      this.$api.systemset
        .paylist({
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 代付添加
    payadd() {
      this.$api.systemset
        .payadd({
          mark: this.addpaydata.paytype,
          markName: this.addpaydata.name,
          reqUrl: this.addpaydata.net,
          partner: this.addpaydata.accout,
          accountName: this.addpaydata.accoutname,
          email: this.addpaydata.payaccout,
          remark: this.addpaydata.remark,
          appSecret: this.addpaydata.subcode,
          publicKey: this.addpaydata.pubcode,
          securityKey: this.addpaydata.supsubcode,
          redirectUrl: this.addpaydata.area
        })
        .then((data) => {
          if (data.status === 200) {
            this.addpaydata.show = false;
            this.$messageSuccess('添加成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加弹框的初始化
    addinit() {
      this.addpaydata.id = '';
      this.addpaydata.flag = true;
      this.addpaydata.paytype = 'alipay';
      this.addpaydata.name = '';
      this.addpaydata.net = '';
      this.addpaydata.accout = '';
      this.addpaydata.accoutname = '';
      this.addpaydata.payaccout = '';
      this.addpaydata.remark = '';
      this.addpaydata.subcode = '';
      this.addpaydata.pubcode = '';
      this.addpaydata.supsubcode = '';
      this.addpaydata.area = '';
    },
    // 删除代理请求
    paydelete(data) {
      this.$api.systemset
        .paydelete({
          id: data
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除代理
    handleClose(data) {
      this.$confirm('是否删除该代付配置?')
        .then(() => {
          this.paydelete(data);
        })
        .catch(() => {});
    },
    // 代理信息
    payinfo(data) {
      this.$api.systemset
        .payinfo({
          id: data
        })
        .then((data) => {
          if (data.status === 200) {
            this.addpaydata.flag = false;
            this.addpaydata.id = data.data.id;
            this.addpaydata.paytype = data.data.mark;
            this.addpaydata.name = data.data.markName;
            this.addpaydata.net = data.data.reqUrl;
            this.addpaydata.accout = data.data.partner;
            this.addpaydata.accoutname = data.data.accountName;
            this.addpaydata.payaccout = data.data.email;
            this.addpaydata.remark = data.data.remark;
            this.addpaydata.subcode = data.data.appSecret;
            this.addpaydata.pubcode = data.data.publicKey;
            this.addpaydata.supsubcode = data.data.securityKey;
            this.addpaydata.area = data.data.redirectUrl;
            this.addpaydata.show = true;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑更新
    payupdate() {
      this.$api.systemset
        .payedit({
          id: this.addpaydata.id,
          mark: this.addpaydata.paytype,
          markName: this.addpaydata.name,
          reqUrl: this.addpaydata.net,
          partner: this.addpaydata.accout,
          accountName: this.addpaydata.accoutname,
          email: this.addpaydata.payaccout,
          remark: this.addpaydata.remark,
          appSecret: this.addpaydata.subcode,
          publicKey: this.addpaydata.pubcode,
          securityKey: this.addpaydata.supsubcode,
          redirectUrl: this.addpaydata.area
        })
        .then((data) => {
          if (data.status === 200) {
            this.addpaydata.show = false;
            this.$messageSuccess('更新成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.dialoglist {
  ul {
    padding-left: 30px;
    li {
      margin-bottom: 10px;
      .tit {
        float: left;
        width: 100px;
        height: 30px;
        line-height: 30px;
      }
      .txtbox {
        float: left;
        width: 700px;
        .tip {
          margin-left: 15px;
          color: red;
        }
      }
    }
  }
}
</style>
